module.exports = __webpack_public_path__ + "static/media/screenshot-report2x.d89bdd1a.png";